import "../css/eventsList.css";
import EventCard from "./eventCard.js"
import EditEvent from "./editEvent.js"
import {useState, useEffect} from "react";
import useLiveLocation from "../hooks/useLiveLocation";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function ShowEvents ({fetchNearestEvents, events, performCheckinUpdate, performLikeUpdate, performEventDetailUpdate, onClose, user}) {
    const liveLoc = useLiveLocation();
    let username = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER"))['username']);
    const [deleteTrigger, setDeleteTrigger] = useState(0);
   
    useEffect(() => {

       fetchNearestEvents();
        
    }, [deleteTrigger]);

    const handleEventDelete = () => {
      setDeleteTrigger(prev => prev + 1);
  };

  const {language} = useLanguage();

  const translations = {
    en: {
      noEventsToDisplay: "There are currently no events to display",
      checkIns: "check ins",
      likedEvents: "Liked events",
      myEvents: "My events",
      happeningNow: "Happening now",
      backToAllEvents: "Back to all events",
      showFilterOptions: "Show filter options",
      hideFilterOptions: "Hide filter options",
      ordering: "Ordering (only one may be applied)",
      soonestFirst: "Soonest first",
      latestFirst: "Latest first",
      newestFirst: "Newest first",
      oldestFirst: "Oldest first",
      closestToMe: "Closest to me (default)",
      furthestFromMe: "Furthest from me",
      applyFilters: "Apply filters",
      showingNearestEventsFirst: "Showing nearest upcoming events first",
      showingSoonestEventsFirst: "Showing soonest upcoming events first",
      noLikedEvents: "You don't have any liked events",
      noCheckedEvents: "You have not checked into any events",
      noCreatedEvents: "You have not created any events",
      noEventsHappening: "There are no events happening right now",
      noFilteredEvents: "Sorry, no events matched the filters you applied",
      event: "Event",
      eventType: "Event Type: ",
      family: "Family: ",
      babyAndToddlers: "Baby and Toddlers: ",
      musicAndDance: "Music and Dance: ",
      conversationGroup: "Conversation Group: ",
      artsAndCrafts: "Arts and Crafts: ",
      lecture: "Talk/Lecture: ",
      universityEvent: "University Event: ",
      session: "Session: ",
      pubNight: "Pub Night: ",
      religious: "Religious: ",
      meeting: "Meeting: ",
      coffeeMorning: "Coffee Morning: ",
      proficiencyLevel: "proficiencyLevel: ",
      beginner: "Beginner: ",
      intermediate: "Intermediate: ",
      advanced: "Advanced: ",
      allLevels: "All Levels: ",
      ageBracket: "Age Bracket: ",
      preSchoolChildren: "Pre-School Children: ",
      schoolAgedChildren: "School-Aged Children: ",
      teenagers: "Teenagers: ",
      adults: "Adults: ",
      allAgesWelcome: "All Ages Welcome: ",
      language: "Language: ",
      gaelicOnly: "Gaelic Only: ",
      gaelicAndEnglish: "Gaelic and English: ",
    },

    gd: {
      noEventsToDisplay: "Chan eil tachartasan an làthair airson an taisbeanadh",
      checkIns: "Clàraidhean",
      likedEvents: "Tachartasan measail",
      myEvents: "Mo thachartasan",
      happeningNow: "A' tachairt a-nis",
      backToAllEvents: "Air ais gu na tachartasan uile ",
      showFilterOptions: "Seall roghainnean sìolaidh",
      hideFilterOptions: "Falaich roghainnean sìolaidh",
      ordering: "Òrdachadh (aon a-mhàin ri chleachdadh) ",
      soonestFirst: "As tràithe an toiseach",
      latestFirst: "As fhadalaiche an toiseach",
      newestFirst: "As ùire an toiseach",
      oldestFirst: "As sine an toiseach",
      closestToMe: "As fhaisge dhomh (bun-roghainn)",
      furthestFromMe: "As fhaide air falbh bhuam",
      applyFilters: "Cuir sìoltachain an gnìomh",
      showingNearestEventsFirst: "Taisbeanadh nan tachartasan as fhaisge an toiseach ",
      showingSoonestEventsFirst: "Taisbeanadh nan tachartasan as luaithe an toiseach ",
      noLikedEvents: "Chan eil tachartasan measail sam bith agad",
      noCheckedEvents: "Chan eil thu air clàradh a-steach do thachartasan sam bith",
      noCreatedEvents: "Chan eil thu air tachartasan sam bith a chruthachadh",
      noEventsHappening: "Chan eil tachartasan sam bith a' tachairt an-dràsta",
      noFilteredEvents: "Duilich, cha robh tachartasan sam bith a' maidseadh nan sìoltachain agad",
      event: "Tachartas",
      eventType: "Seòrsa Tachartais: ",
      family: "Teaghlach: ",
      babyAndToddlers: "Leanabh is Pàistean: ",
      musicAndDance: "Ceòl is Dannsa: ",
      conversationGroup: "Buidheann Còmhraidh: ",
      artsAndCrafts: "Ealain is Ciùird: ",
      lecture: "Còmhradh / Òraid: ",
      universityEvent: "Tachartas Oilthighe: ",
      session: "Seisean: ",
      pubNight: "Oidhche Taigh-seinnse: ",
      religious: "Cràbhach: ",
      meeting: "Coinneamh: ",
      coffeeMorning: "Madainn Cofaidh: ",
      proficiencyLevel: "Ìre Comais: ",
      beginner: "Neach-tòiseachaidh: ",
      intermediate: "Eadar-mheadhanach: ",
      advanced: "Adhartach: ",
      allLevels: "Na h-ìrean uile",
      ageBracket: "Raon aoise : ",
      preSchoolChildren: "Clànn Fo-sgoile: ",
      schoolAgedChildren: "Clann Aois-sgoile: ",
      teenagers: "Deugairean: ",
      adults: "Inbhich: ",
      allAgesWelcome: "Gach Aois Di-beathte: ",
      language: "Cànan",
      gaelicOnly: "Cànan",
      gaelicAndEnglish: "Gàidhlig agus Beurla",
        
    },
};

    const [isNearestEventsVisible, setIsNearestEventsVisible] = useState(true);
    const [isLikedEventsVisible, setIsLikedEventsVisible] = useState(false);
    const [isHostedEventsVisible, setIsHostedEventsVisible] = useState(false);
    const [isAttendedEventsVisible, setIsAttendedEventsVisible] = useState(false);
    const [isRefinedEventsVisible, setIsRefinedEventsVisible] = useState(false);
    const [isFilterMenuVisible, setIsFilterMenuVisible] = useState(false);
    const [isOnNowEventsVisible, setIsOnNowEventsVisible] = useState(false)
    const [isEditEventVisible, setIsEditEventVisible] = useState(false);

    const [likedEvents, setLikedEvents] = useState([]);
    const [userHostedEvents, setUserHostedEvents] = useState([]);
    const [attendedEvents, setAttendedEvent] = useState([]);
    const [refinedEvents, setRefinedEvents] = useState([]);
    const [onNowEvents, setOnNowEvents] = useState([]);
    const [eventToEdit, setEventToEdit] = useState([]);

    //event type refinement
    const [isFamily, setIsFamily] = useState(false);
    const [isBabyAndToddlers, setIsBabyAndToddler] = useState(false);
    const [isMusicAndDance, setIsMusicAndDance] = useState(false);
    const [isConversation, setIsConversation] = useState(false);
    const [isArtsAndCrafts, setIsArtsAndCrafts] = useState(false);
    const [isTalk, setIsTalk] = useState(false);
    const [isUniversityEvent, setIsUniversityEvent] = useState(false);
    const [isSession, setIsSession] = useState(false);
    const [isPubNight, setIsPubNight] = useState(false);
    const [isReligious, setIsReligious] = useState(false);
    const [isMeeting, setIsMeeting] = useState(false);
    const [isCoffeeMorning, setIsCoffeeMorning] = useState(false);

    //event proficiency refinement
    const [isBeginner, setIsBeginner] = useState(false);
    const [isIntermediate, setIsIntermediate] = useState(false);
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [isAllLevels, setIsAllLevels] = useState(false);
    
    //age bracket refinement 
    const [allAges, setAllAges] = useState(false);
    const [adults, setAdults] = useState(false);
    const [teenagers, setTeenagers] = useState(false);
    const [schoolAge, setSchoolAge] = useState(false);
    const [preSchoolAge, setPreSchoolAge] = useState(false);

    //language refinement
    const [gaelicOnly, setGaelicOnly] = useState(false);
    const [gaelicAndEnglish, setGaelicAndEnglish] = useState(false);

    //event ordering refinement
    const [closestOrder, setClosestOrder] = useState(false);
    const [furthestOrder, setFurthestOrder] = useState(false);
    const [soonestOrder, setSoonestOrder] = useState(false);
    const [latestOrder, setLatestOrder] = useState(false);
    const [newestOrder, setNewestOrder] = useState(false);
    const [oldestOrder, setOldestOrder] = useState(false);



    // filter helper functions - fetch data and toggle displays 

    function clearFilters() {

        fetchNearestEvents();
        setIsHostedEventsVisible(false);
        setIsEditEventVisible(false);
        setIsLikedEventsVisible(false);
        setIsNearestEventsVisible(true);
        setIsRefinedEventsVisible(false);
        setIsAttendedEventsVisible(false);
        setIsOnNowEventsVisible(false);

    }

    //get events this user has saved (liked)
    const fetchLikedEvents = async () => {

        let username = JSON.parse(sessionStorage.getItem("USER"))['username']

        try{

          const response = await fetch(
            `${BASE_URL}/api/liked_events/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
  
              body: JSON.stringify({ 
                username: username,
              }),
            });
  
            const data = await response.json();
            setLikedEvents(data);

            setIsLikedEventsVisible(true);
            setIsEditEventVisible(false);
            setIsNearestEventsVisible(false);
            setIsHostedEventsVisible(false);
            setIsRefinedEventsVisible(false);
            setIsAttendedEventsVisible(false);
            setIsOnNowEventsVisible(false);
  
          } catch (error) {
            console.error('Error fetching liked event data:', error);
          }
  
    };


     //get events this user has checked in to (attended)
     const fetchAttendedEvents = async () => {

        let username = JSON.parse(sessionStorage.getItem("USER"))['username']

        try{

          const response = await fetch(
            `${BASE_URL}/api/checked_in_events/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
  
              body: JSON.stringify({ 
                username: username,
              }),
            });
  
            const data = await response.json();
            setAttendedEvent(data);

            setIsAttendedEventsVisible(true);
            setIsLikedEventsVisible(false);
            setIsEditEventVisible(false);
            setIsNearestEventsVisible(false);
            setIsHostedEventsVisible(false);
            setIsRefinedEventsVisible(false);
            setIsOnNowEventsVisible(false);
  
          } catch (error) {
            console.error('Error fetching liked event data:', error);
          }
  
    };

    //get the events this user has created 
    const fetchUserHostedEvents = async () => {

        let username = JSON.parse(sessionStorage.getItem("USER"))['username']

        try{

          const response = await fetch(
            `${BASE_URL}/api/hosted_events/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
  
              body: JSON.stringify({ 
                username: username,
              }),
            });
  
            const data = await response.json();
            setUserHostedEvents(data);

            setIsHostedEventsVisible(true);
            setIsEditEventVisible(false);
            setIsNearestEventsVisible(false);
            setIsLikedEventsVisible(false);
            setIsRefinedEventsVisible(false);
            setIsAttendedEventsVisible(false);
            setIsOnNowEventsVisible(false);
  
          } catch (error) {
            console.error('Error fetching liked event data:', error);
          }
  
    };

    const fetchRefinedEvents = async () => {
        try{

            const response = await fetch(
              `${BASE_URL}/api/refined_events/`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
    
                body: JSON.stringify({ 
                  isFamily: isFamily,
                  isBabyAndToddlers: isBabyAndToddlers,
                  isMusicAndDance: isMusicAndDance,
                  isConversation: isConversation,
                  isArtsAndCrafts: isArtsAndCrafts,
                  isTalk: isTalk,
                  isUniversityEvent: isUniversityEvent,
                  isSession: isSession,
                  isPubNight: isPubNight,
                  isReligious: isReligious,
                  isMeeting: isMeeting,
                  isCoffeeMorning: isCoffeeMorning,

  
                  isBeginner: isBeginner,
                  isIntermediate: isIntermediate,
                  isAdvanced: isAdvanced,
                  isAllLevels: isAllLevels,

                  isPreSchool: preSchoolAge,
                  isSchoolAge: schoolAge,
                  isTeenage: teenagers,
                  isAdult: adults,
                  isAllAges: allAges,

                  isGaelic: gaelicOnly, 
                  isGaelicAndEnglish: gaelicAndEnglish,
  
                  closestOrder: closestOrder,
                  furthestOrder: furthestOrder,
                  soonestOrder: soonestOrder, 
                  latestOrder: latestOrder, 
                  newestOrder: newestOrder, 
                  oldestOrder: oldestOrder, 
  
                  userLat: liveLoc.lat, 
                  userLong: liveLoc.long,
                }),
              });
  
              const data = await response.json();
              setRefinedEvents(data);
  
              setIsRefinedEventsVisible(true);
              setIsEditEventVisible(false);
              setIsNearestEventsVisible(false);
              setIsLikedEventsVisible(false);
              setIsHostedEventsVisible(false);
              setIsAttendedEventsVisible(false);
              setIsOnNowEventsVisible(false);
    
            } catch (error) {
              console.error('Error fetching liked event data:', error);
            }
    }



    //get the events this user has created 
    const fetchEventToEdit = async (event_id) => {

        try{

          const response = await fetch(
            `${BASE_URL}/api/event_to_edit/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
  
              body: JSON.stringify({ 
                event_id: event_id,
              }),
            });
  
            const data = await response.json();
            setEventToEdit(data);

            setIsEditEventVisible(true);
            setIsHostedEventsVisible(false);
            setIsLikedEventsVisible(false);
            setIsNearestEventsVisible(false);
            setIsRefinedEventsVisible(false);
            setIsAttendedEventsVisible(false);
            setIsOnNowEventsVisible(false);
            
  
          } catch (error) {
            console.error('Error fetching event data for editing:', error);
          }
  
    };

    //get events which are on now 
    const fetchOnNowEvents = async () => {
        try{
          const response = await fetch(`${BASE_URL}/api/events_on_now/`);
          if (!response.ok){
            throw new Error('Unable to receive successful network response');
          }
          const data = await response.json();
          setOnNowEvents(data);

          setIsOnNowEventsVisible(true);
          setIsEditEventVisible(false);
          setIsHostedEventsVisible(false);
          setIsLikedEventsVisible(false);
          setIsNearestEventsVisible(false);
          setIsRefinedEventsVisible(false);
          setIsAttendedEventsVisible(false);

        } catch (error) {
          console.error('Error fetching event data:', error);
        }
    };

    
    //handle refinement form
    const handleRefine = async (event) => {
        event.preventDefault();
        fetchRefinedEvents(); 
    }

    
    const handleEdit = async(event_id) => {
        fetchEventToEdit(event_id);
    }


    //we only want user to be able to tick one of the filtering options 
    function orderChange(order, e) {
        
        let idArray = ["closest-check", "furthest-check", "soonest-check", "latest-check", 
                        "newest-check", "oldest-check"];

        let checkOrder = "";

        if (order === "closest"){
            setClosestOrder(e.target.checked);
            checkOrder = "closest-check";

        }else if (order === "furthest"){
            setFurthestOrder(e.target.checked);
            checkOrder = "furthest-check";

        }else if (order === "soonest"){
            setSoonestOrder(e.target.checked);
            checkOrder = "soonest-check";

        }else if (order === "latest"){
            setLatestOrder(e.target.checked);
            checkOrder = "latest-check";

        }else if (order === "newest"){
            setNewestOrder(e.target.checked);
            checkOrder = "newest-check";

        }else if (order === "oldest"){
            setOldestOrder(e.target.checked);
            checkOrder = "oldest-check";
        }
        
        let filteredArray = idArray.filter(elem => elem !== checkOrder)

        if (!liveLoc.loadComplete || liveLoc.error){
            filteredArray = filteredArray.filter(elem => elem!== "closest-check" && elem!=="furthest-check")
        }

        //amend button disabled status
        if (e.target.checked){
            
            for (var id of filteredArray){
                console.log(id);
                document.getElementById(id).disabled = true;
            } 
            document.getElementById(checkOrder).disabled = false;

        }else{
            for (var id of filteredArray){
                console.log(id);
                document.getElementById(id).disabled = false;
            }
        }

    }


 return(
    <div>

      <div className="event-header">
        <h2>{translations[language].event}</h2>
        <button className= "close-x" onClick={onClose}>&times;</button> 
      </div>

      {events.length === 0 && (
          <div className="event-card">
            <p>{translations[language].noEventsToDisplay}</p>
          </div>
      )}

      <div className="filters">
            {username !== null && (
              <>
                <button className = "filter-button" onClick = {fetchAttendedEvents}> {translations[language].checkIns} </button>
                <button className = "filter-button" onClick = {fetchLikedEvents}> {translations[language].likedEvents} </button>
                <button className = "filter-button" onClick={fetchUserHostedEvents}> {translations[language].myEvents} </button>
              </>
            )}
            <button className = "filter-button" onClick={fetchOnNowEvents}> {translations[language].happeningNow} </button>
            {!isNearestEventsVisible && (
                <button className = "filter-button" onClick = {clearFilters}> {translations[language].backToAllEvents}</button>
            )}
      </div>


      {isNearestEventsVisible && (
        <>

        {!isFilterMenuVisible && (
            <button className = "toggle-filters" onClick={() => setIsFilterMenuVisible(true)}> {translations[language].showFilterOptions} </button>
        )}
        { isFilterMenuVisible && (
            
        <div className="refine-events">

            <button className = "toggle-filters" onClick={() => setIsFilterMenuVisible(false)}> {translations[language].hideFilterOptions} </button>

            <form onSubmit={handleRefine}>

                <h4>{translations[language].eventType}</h4>
                {translations[language].family} <input type="checkbox" checked = {isFamily} onChange={(e) => setIsFamily(e.target.checked)} />
                {translations[language].babyAndToddlers} <input type="checkbox" checked = {isBabyAndToddlers} onChange={(e) => setIsBabyAndToddler(e.target.checked)} />
                {translations[language].musicAndDance} <input type="checkbox" checked = {isMusicAndDance} onChange={(e) => setIsMusicAndDance(e.target.checked)} />
                {translations[language].conversationGroup} <input type="checkbox" checked = {isConversation} onChange={(e) => setIsConversation(e.target.checked)} />
                {translations[language].artsAndCrafts} <input type="checkbox" checked = {isArtsAndCrafts} onChange={(e) => setIsArtsAndCrafts(e.target.checked)} />
                {translations[language].lecture} <input type="checkbox" checked = {isTalk} onChange={(e) => setIsTalk(e.target.checked)} />
                {translations[language].universityEvent} <input type="checkbox" checked = {isUniversityEvent} onChange={(e) => setIsUniversityEvent(e.target.checked)} />
                {translations[language].session} <input type="checkbox" checked = {isSession} onChange={(e) => setIsSession(e.target.checked)} />
                {translations[language].pubNight} <input type="checkbox" checked = {isPubNight} onChange={(e) => setIsPubNight(e.target.checked)} />
                {translations[language].religious} <input type="checkbox" checked = {isReligious} onChange={(e) => setIsReligious(e.target.checked)} />
                {translations[language].meeting} <input type="checkbox" checked = {isMeeting} onChange={(e) => setIsMeeting(e.target.checked)} />
                {translations[language].coffeeMorning} <input type="checkbox" checked = {isCoffeeMorning} onChange={(e) => setIsCoffeeMorning(e.target.checked)} />

                <h4>{translations[language].proficiencyLevel} </h4>
                {translations[language].beginner} <input type="checkbox" checked = {isBeginner} onChange={(e) => setIsBeginner(e.target.checked)} />
                {translations[language].intermediate} <input type="checkbox" checked = {isIntermediate} onChange={(e) => setIsIntermediate(e.target.checked)} />
                {translations[language].advanced} <input type="checkbox" checked = {isAdvanced} onChange={(e) => setIsAdvanced(e.target.checked)} />
                {translations[language].allLevels} <input type="checkbox" checked = {isAllLevels} onChange={(e) => setIsAllLevels(e.target.checked)} />

                <h4>{translations[language].ageBracket} </h4>
                {translations[language].preSchoolChildren} <input type="checkbox" checked = {preSchoolAge} onChange={(e) => setPreSchoolAge(e.target.checked)} />
                {translations[language].schoolAgedChildren} <input type="checkbox" checked = {schoolAge} onChange={(e) => setSchoolAge(e.target.checked)} />
                {translations[language].teenagers} <input type="checkbox" checked = {teenagers} onChange={(e) => setTeenagers(e.target.checked)} />
                {translations[language].adults} <input type="checkbox" checked = {adults} onChange={(e) => setAdults(e.target.checked)} />
                {translations[language].allAgesWelcome} <input type="checkbox" checked = {allAges} onChange={(e) => setAllAges(e.target.checked)} />

                <h4>{translations[language].language} </h4>
                {translations[language].gaelicOnly} <input type="checkbox" checked = {gaelicOnly} onChange={(e) => setGaelicOnly(e.target.checked)} />
                {translations[language].gaelicAndEnglish} <input type="checkbox" checked = {gaelicAndEnglish} onChange={(e) => setGaelicAndEnglish(e.target.checked)} />

                <h4> {translations[language].ordering} </h4>
                {translations[language].soonestFirst} <input id="soonest-check" type="checkbox" checked = {soonestOrder} onChange={(e) => orderChange("soonest", e)} />
                {translations[language].latestFirst} <input id="latest-check" type="checkbox" checked = {latestOrder} onChange={(e) => orderChange("latest", e)} />
                {translations[language].newestFirst} <input id="newest-check" type="checkbox" checked = {newestOrder} onChange={(e) => orderChange("newest", e)} />
                {translations[language].oldestFirst} <input id="oldest-check" type="checkbox" checked = {oldestOrder} onChange={(e) => orderChange("oldest", e)} />

                {liveLoc.loadComplete && !liveLoc.error && (
                    <div>
                        {translations[language].closestToMe} <input id="closest-check" type="checkbox" checked = {closestOrder} onChange={(e) => orderChange("closest", e)} />
                        {translations[language].furthestFromMe} <input id="furthest-check" type="checkbox" checked = {furthestOrder} onChange={(e) => orderChange("furthest", e) } />
                    </div>
                )}

                <br/><button className="filter-button" type = "submit">{translations[language].applyFilters}</button>
       
            </form>
        </div>
        )}


        {liveLoc.loadComplete && !liveLoc.error && events.length!==0 && (
            <div className="event-card">
                <p>{translations[language].showingNearestEventsFirst}</p>
            </div>
        )}

        {!liveLoc.loadComplete || liveLoc.error && events.length!==0 &&(
            <div className="event-card">
                <p>{translations[language].showingSoonestEventsFirst}</p>
            </div>
        )}


        <div>
        {/* use a map to loop through the events and render them out. */}
        {events.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchNearestEvents}
                    handleEdit={handleEdit}
                    onDeleteSuccess={handleEventDelete}
                    user={user}
                />
        
            )
        })}
        </div>
        </>
      )}


    {/* use a map to loop through the liked events and render them out. */}
    {isLikedEventsVisible && (
        <div>

        {likedEvents.length === 0 && (
            <div className="event-card">
                <p>{translations[language].noLikedEvents}</p>
            </div>
        )}



        {likedEvents.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchLikedEvents}
                    handleEdit={handleEdit}
                />
        
            )
        })}
        </div>
    )}
    

    {isAttendedEventsVisible && (
        <div>

        {attendedEvents.length === 0 && (
            <div className="event-card">
                <p>{translations[language].noCheckedEvents}</p>
            </div>
        )}

        {attendedEvents.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchAttendedEvents}
                    handleEdit={handleEdit}
                />
        
            )
        })}
        </div>
    )}


    {/* use a map to loop through the hosted events and render them out. */}
    {isHostedEventsVisible && (
        <div>

        {userHostedEvents.length === 0 && (
            <div className="event-card">
                <p>{translations[language].noCreatedEvents}</p>
            </div>
        )}
        {userHostedEvents.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchUserHostedEvents}
                    handleEdit={handleEdit}
                />
        
            )
        })}
        </div>
    )}


    {/* use a map to loop through the events that are happening now and render them out. */}
    {isOnNowEventsVisible && (
        <div>

        {onNowEvents.length === 0 && (
            <div className="event-card">
                <p>{translations[language].noEventsHappening}</p>
            </div>
        )}

        {onNowEvents.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchOnNowEvents}
                    handleEdit={handleEdit}
                />
        
            )
        })}
        </div>
    )}



    {/* use a map to loop through the liked events and render them out. */}
    {isRefinedEventsVisible && (
        <div>

        {refinedEvents.length === 0 && (
            <div className="event-card">
                <p>{translations[language].noFilteredEvents}</p>
            </div>
        )}

        {refinedEvents.map(event => {
            return(
                <EventCard 
                    onclose={onClose}
                    event_id = {event.id}
                    title={event.title}
                    description={event.description} 
                    start_time={event.start_time} 
                    end_time={event.end_time} 
                    start_date={event.start_date} 
                    end_date={event.end_date} 
                    postcode={event.postcode}
                    latitude={event.latitude}
                    longitude={event.longitude}
                    event_picture={event.picture}
                    event_proficiency={event.proficiency}
                    type={event.type}
                    age_bracket={event.age_bracket}
                    language={event.language}
                    host_username={event.host_username}
                    host_name={event.host_name}
                    check_ins={event.check_ins}
                    number_likes={event.likes}
                    performCheckinUpdate = {performCheckinUpdate}
                    performLikeUpdate = {performLikeUpdate}
                    fetchEvents = {fetchRefinedEvents}
                    handleEdit={handleEdit}
                />
        
            )
        })}
        </div>
    )}


    {isEditEventVisible && (
        <div>
            <EditEvent
                onclose={onClose}
                event_id = {eventToEdit.id}
                title={eventToEdit.title}
                description={eventToEdit.description} 
                start_time={eventToEdit.start_time} 
                end_time={eventToEdit.end_time} 
                start_date={eventToEdit.start_date} 
                end_date={eventToEdit.end_date} 
                postcode={eventToEdit.postcode}
                latitude={eventToEdit.latitude}
                longitude={eventToEdit.longitude}
                event_picture={eventToEdit.picture}
                event_proficiency={eventToEdit.proficiency}
                type={eventToEdit.type}
                age_bracket={eventToEdit.age_bracket}
                language={eventToEdit.language}
                performCheckinUpdate = {performCheckinUpdate}
                performLikeUpdate = {performLikeUpdate}
                performEventDetailUpdate = {performEventDetailUpdate}
                fetchEvents = {fetchEventToEdit}
            />
        </div>
    )}
     
    </div>
 )

};

export default ShowEvents;